<mat-form-field>
  <mat-label>Enter a date range</mat-label>
  <mat-date-range-input [rangePicker]="picker">
    <input matStartDate placeholder="Start date" [(ngModel)]="startDate" />
    <input matEndDate placeholder="End date" [(ngModel)]="endDate" />
  </mat-date-range-input>
  <mat-datepicker-toggle matSuffix [for]="picker" />
  <mat-date-range-picker #picker />
</mat-form-field>

<mat-form-field class="col-4 ms-3">
  <mat-label>Activity Codes</mat-label>
  <input
    matInput
    type="text"
    placeholder="Activity Codes"
    [(ngModel)]="activityCode"
  />
  <mat-hint>Comma delimited list, no spaces. Default is 'ALL'.</mat-hint>
</mat-form-field>

<mat-form-field class="ms-3">
  <input
    type="text"
    placeholder="Search For a Unit"
    matInput
    name="unitsControl"
    [matAutocomplete]="auto"
    [formControl]="unitsControl"
    [(ngModel)]="selectedUnit"
    (blur)="checkSelection()"
  />
  <mat-autocomplete #auto="matAutocomplete">
    @for (unit of filteredUnits; track $index) {
      <mat-option [value]="unit.id">
        {{ unit.name }}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
<button
  type="button"
  mat-raised-button
  color="primary"
  class="mx-auto ms-3"
  [disabled]="!selectedUnit || !startDate || !endDate"
  (click)="getSessionActivity()"
>
  Get Report
</button>
@if (unitSessionActivity && unitSessionActivity.data) {
  <button
    type="button"
    mat-button
    color="primary"
    class="grid-button pull-right"
    (click)="exportToExcel(unitUsageGrid)"
  >
    <mat-icon>cloud_download</mat-icon>Download Excel File
  </button>

  <kendo-grid
    #unitUsageGrid="kendoGrid"
    class="col-12 mt-3 usage-grid"
    [hidden]="!unitSessionActivity.data"
    [kendoGridBinding]="unitSessionActivity.data"
    [height]="600"
    [navigable]="true"
  >
    @for (col of unitSessionActivity.header; track $index) {
      <kendo-grid-column [field]="col.DataField" [title]="col.Label" />
    }
    <kendo-grid-excel fileName="RightBridge-UnitSessionActivity.xlsx" />
  </kendo-grid>
}
<ngx-loading [show]="loading" />
